import styles from "./GridLayout.module.css";

import img1 from '../../assets/benefits-img-1.png';
import img2 from '../../assets/benefits-img-2.png';
import img3 from '../../assets/benefits-img-3.png';
import bgImage1 from '../../assets/benefits-background-1.png';
import bgImage2 from '../../assets/benefits-background-2.png';
import bgImage3 from '../../assets/background-cans.jpeg';
import bgImage4 from '../../assets/benefits-background-4.png';


export default function GridLayout() {
  
  const myStyle1 = {
    backgroundImage: `url(${bgImage1})`,
  }
  
  const myStyle2 = {
    backgroundImage: `url(${bgImage2})`,
  }
  
  const myStyle3 = {
    backgroundImage: `url(${bgImage3})`,
  }
  
  const myStyle4 = {
    backgroundImage: `url(${bgImage4})`,
  }

  return (
    <div className={styles.container}>

      {/* LEFT */}
      <div className={styles.left}>
        <div className={styles.box} style={{background: "#EA7D1A1A", paddingTop: "50px"}}>
          <img src={img1} alt="img" />
          {/* <img style={{marginBottom: "55px"}} src={img1} alt="img" /> */}
          <h4 style={{color: "#602E00"}}>Pure Fruit Refreshment</h4>
          <p style={{color: "#311800B2"}}>Made with delicious fruit blends for a naturally refreshing taste.</p>
        </div>
        <div style={myStyle2} className={`${styles.boxx} ${styles.tall}`}></div>
      </div>

      {/* MIDDLE */}
      <div className={styles.middle}>
        <div className={styles.box} style={{background: "#008CFF1A"}}>
          <img src={img2} alt="img" />
          <h4 style={{color: "#0D436F"}}>Refreshment You Can Feel</h4>
          <p style={{color: "#192834B2"}}>A light and refreshing fruit drink that keeps you energized and refreshed all day.</p>
        </div>
        <div style={myStyle3} className={styles.boxxx}></div>
        <div className={styles.box} style={{background: "#1EA21E26"}}>
          <img src={img3} alt="img" />
          <h4 style={{color: "#0B520B"}}>Fresh Taste, Every Sip</h4>
          <p style={{color: "#274227B2"}}>Smooth fruit flavors with the perfect balance of sweetness and freshness</p>
        </div>
      </div>

      {/* RIGHT */}
      <div className={styles.right}>
        <div style={myStyle1} className={`${styles.boxx} ${styles.tall}`}></div>
        <div style={myStyle4} className={styles.boxxx}></div>
      </div>

    </div>
  );
}

// const Container1 = () => {
//   return (
//     <div className={styles.box}>
//       <img src={img} alt="img" />
//       <h4>Pure Fruit Refreshment</h4>
//       <p>Made with delicious fruit blends for a naturally refreshing taste.</p>
//     </div>
//   )
// }